import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    dismiss: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Theme provider dismiss button for toast */
            dismiss: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ThemeProvider.dismiss?c=12vpt6ppn1wyz", defaultMessage: "Dismiss" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
